import { apiSlice } from "../../app/api/apiSlice";

export const jobStatusApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		jobStatus: builder.mutation({
			query: (credentials) => ({
				url: `/api/v1/loan/get_export_job_status/${credentials?.job_id}/`,
				method: "GET",
			}),
		}),
	}),
});

export const { useJobStatusMutation } = jobStatusApiSlice;
